/* lg-facets-band.js - JET-2 (23 Sep). The desktop facets sidebar takes the
   foreground of whichever brand band is behind it.

   The bands' grounds bleed full width (lg-design.css, block 46 / JET-2), so
   the sticky sidebar at >=990 scrolls over them - and over the Stattera band
   its espresso type sits on #141414. The sidebar is not inside any band, so it
   cannot inherit the scheme; instead each facet row is tagged with the
   data-band-fg of the band its own vertical midpoint is over, and CSS reads
   data-fg. Per row, not per sidebar, so a sidebar straddling two bands
   recolours top and bottom independently. Rows over no band (the gaps
   between bands, the page above and below) have data-fg removed and keep the
   default.

   Rects are read with getBoundingClientRect, which already includes the
   sticky offset and the sidebar's own internal scroll - no offset maths here
   to drift from block 42's `top`.

   Cost control: an IntersectionObserver tracks which bands are within a
   viewport of the screen (the margin keeps a band live while only the space
   after it, which carries its ground, is on screen); with none on screen the scroll handler does nothing past one
   check. Work is rAF-throttled to one pass per frame. Only data-fg changes,
   so there is no layout shift; the colour transition lives in lg-design.css.

   Dawn's facets.js re-renders the facets and #ProductGridContainer from a
   fetch on every filter change, so nothing is cached across renders: rows and
   bands are re-queried each pass, and a MutationObserver on the
   .facets-vertical wrapper (which survives re-renders) re-observes new bands.

   Desktop form only (#FacetFiltersForm is small-hide medium-hide). The mobile
   drawer is a separate menu-drawer and is never touched. */
(function () {
  'use strict';

  if (window.lgFacetsBandBound) return; // double-bind guard
  window.lgFacetsBandBound = true;

  var ROWS = [
    '#FacetFiltersForm .active-facets-vertical-filter',
    '#FacetFiltersForm .facets__summary',
    '#FacetFiltersForm .facets__header-vertical',
    '#FacetFiltersForm .facets__item',
    '#FacetFiltersForm .facets__price',
    '#FacetFiltersForm show-more-button'
  ].join(',');
  var BANDS = '.lg-brand-band[data-band-fg]';
  var DESKTOP = window.matchMedia('(min-width: 990px)');

  var visible = new Set();
  var observed = new WeakSet();
  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) visible.add(e.target);
          else visible.delete(e.target);
        });
        schedule();
      }, { rootMargin: '100% 0px 100% 0px' })
    : null;

  function observeBands() {
    if (!io) return;
    visible.forEach(function (b) { if (!b.isConnected) visible.delete(b); });
    document.querySelectorAll(BANDS).forEach(function (b) {
      if (observed.has(b)) return;
      observed.add(b);
      io.observe(b);
    });
  }

  function clearAll() {
    document.querySelectorAll('#FacetFiltersForm [data-fg]').forEach(function (el) {
      el.removeAttribute('data-fg');
    });
  }

  var cleared = true;
  function update() {
    queued = false;
    if (!DESKTOP.matches || (io && visible.size === 0)) {
      if (!cleared) { clearAll(); cleared = true; }
      return;
    }
    // A band's reach includes the space after it (JET-2c, lg-design.css):
    // down to the next band's top, or for the last band to the bottom of the
    // product-grid section, where its ground now stops.
    var all = Array.from(document.querySelectorAll(BANDS));
    var sec = all.length && all[0].closest('[class*="product-grid-padding"]');
    var end = sec ? sec.getBoundingClientRect().bottom : null;
    var bands = [];
    all.forEach(function (b, i) {
      if (io && !visible.has(b)) return;
      var r = b.getBoundingClientRect();
      var reach = all[i + 1] ? all[i + 1].getBoundingClientRect().top : Math.max(r.bottom, end || r.bottom);
      bands.push({ top: r.top, bottom: reach, fg: b.getAttribute('data-band-fg') });
    });
    var rows = document.querySelectorAll(ROWS);
    // Read every rect first, then write, so the pass never forces a reflow.
    var mids = [];
    for (var i = 0; i < rows.length; i++) {
      var r = rows[i].getBoundingClientRect();
      mids.push(r.height ? (r.top + r.bottom) / 2 : null);
    }
    for (var j = 0; j < rows.length; j++) {
      var fg = null;
      if (mids[j] !== null) {
        for (var k = 0; k < bands.length; k++) {
          if (mids[j] >= bands[k].top && mids[j] < bands[k].bottom) { fg = bands[k].fg; break; }
        }
      }
      if (fg) {
        if (rows[j].getAttribute('data-fg') !== fg) rows[j].setAttribute('data-fg', fg);
      } else if (rows[j].hasAttribute('data-fg')) {
        rows[j].removeAttribute('data-fg');
      }
    }
    cleared = false;
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  }

  // Capture so the sidebar's own overflow-y scroll (block 42) is heard too;
  // scroll and toggle do not bubble.
  document.addEventListener('scroll', schedule, { capture: true, passive: true });
  document.addEventListener('toggle', schedule, true);
  window.addEventListener('resize', schedule, { passive: true });
  if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', schedule);

  function watch() {
    var wrap = document.querySelector('.facets-vertical');
    if (wrap && 'MutationObserver' in window) {
      // class/open only: data-fg writes must not re-trigger the observer.
      new MutationObserver(function () { observeBands(); schedule(); })
        .observe(wrap, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'open'] });
    }
    observeBands();
    schedule();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
